'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withListBlank = undefined;

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withListBlank = exports.withListBlank = function withListBlank(BlankComponent) {
  return function (Component) {
    return (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
      var items = _ref.items,
          isLoading = _ref.isLoading;
      return (0, _isEmpty2.default)(items) && !isLoading;
    }, (0, _recompose.renderComponent)(BlankComponent)))(Component);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/logic/with-list-blank.js
// module id = 2043
// module chunks = 0